/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { getAllUsersData } from 'src/services/userService';
import { IconButton, Menu, MenuItem } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import AddUserForm from './AddUserForm';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link } from 'react-router-dom';
import GradientButton from '../MUICustomButton/GradientButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { UPDATE_USER_DELETE_SUBTITLE_1, UPDATE_USER_DELETE_SUBTITLE_2 } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { deleteUserData } from 'src/services/userService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;

interface UserListPropType {
  "id": number;
  "firstName": string;
  "lastName": string;
  "email": string;
  "password": string | null;
  "isDeleted": boolean;
  "isActive": boolean;
  "createdBy": number;
  "createdOn": string;
  "updatedBy": number;
  "updatedOn": string;
  "deletedBy": string | null;
  "deletedOn": string | null;
  "role": string;
}

interface ApiResponse {
  status: number;
  data: {
    data: UserListPropType[];
  };
}

interface UserDeleteIds {
  "userId": number;
}
interface UserDeleteProps {
  "modifiedBy": number;
  "userLst": UserDeleteIds[];
}

const UserList: React.FC = () => {

  const [userListData, setUserListData] = useState<UserListPropType[]>([])

  const [openAddUserModal, setOpenAddUserModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [showDeleteUserModal, setShowDeleteUserModal] = useState<boolean>(false)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [selectedUserData, setSelectedUserData] = useState<UserListPropType>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getUserListData()
  }, [])

  const getUserListData = (): void => {
    setLoading(true)
    getAllUsersData()
    .then(
      (res: ApiResponse) => {
        if (res.status === 200) {
          setUserListData(res.data.data)
        }
      }
    ) 
    .catch (
      error => console.log("Error: ", error)
    )
    .finally(() => {
      setLoading(false)
    })
  }

  const handleAddUserClick = (): void => {
    setOpenAddUserModal(true)
  }

  const handleCloseAddUserModal = (): void => {
    setOpenAddUserModal(false)
  }

  const handleRefreshPage = (): void => {
    getUserListData()
    handleCloseAddUserModal()
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    debugger
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleActionClose = (event: React.MouseEvent<HTMLElement>, rowData: UserListPropType, action: string | null = null): void => {
    setSelectedUserData(rowData)
    if (action === "delete") {
      setShowDeleteUserModal(true)
    }
    setAnchorActionEl({ ...anchorActionEl, [rowData.id]: null });
  }

  const handleDeleteUserClose = (): void => {
    setShowDeleteUserModal(false)
  }

  const handleDeleteUserConfirm = (): void => {
    setIsModalSaveLoading(true)
    const userId: number = selectedUserData !== undefined ? selectedUserData.id : 0
    const data: UserDeleteProps = {
      "modifiedBy": 1,
      "userLst": [{
        "userId": userId
      }]
    }

    deleteUserData(data)
      .then(
        res => {
          if (res.status === 200) {
            
            NotificationManager.success("User deleted successfully")
            setIsModalSaveLoading(false)
            setShowDeleteUserModal(false)
            getUserListData()
          }
        }
      )
      .catch (
        error => console.log("Error in delete user: ", error)
      )
  }

  const columns: TableColumn<UserListPropType>[] = [
    {
      name: 'Full Name',
      selector: (row: UserListPropType) => row.firstName,
      cell: (row: UserListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted">{row.firstName} {row.lastName}</p>
            </div>
          </div>
        )
      },
      width: '25%',
      sortable: true
    },
    {
      name: 'Email',
      selector: (row: UserListPropType) => row.email,
      width: '25%',
      sortable: true
    },
    {
      name: 'Role',
      selector: (row: UserListPropType) => row.role,
      width: '25%',
      sortable: true
    },
    {
      name: 'Status',
      sortable: false,
      width: "10%",
      // selector: row => row.year,
      cell: (row: UserListPropType) => {
        return row.isActive ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : <div className="badge truncate" style={{
          background: '#FFF5F6',
          padding: '10px 15px',
          color: '#F13139',
          border: '0px'
        }}>Inactive</div>
      }
    },
    {
      name: 'Action',
      // selector: (row: any) => row.role,
      cell: (row: UserListPropType) => {
        console.log("anchorActionEl", anchorActionEl)
        return (
          <div className='flex items-center'>
            <Link to={`/settings/manage-users/edit/${row.id}`} style={{ width: '20px' }}>
              <img src={'/assets/images/icons/EditIcon.svg'} width={20} height={20} alt="" />
            </Link>
            <div className='flex'>
              <IconButton
                aria-label="more"
                id="long-button"
                // aria-controls={open ? 'long-menu' : undefined}
                // aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.id)}
              >
                <MoreVertIcon sx={{ color: "#77869E" }} />
              </IconButton>
              <Menu
                id={`${row.id}`}
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorActionEl[row.id]}
                open={Boolean(anchorActionEl[row.id])}
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}
              >
                <MenuItem onClick={(e) => handleActionClose(e, row, "delete")}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 19" fill="none">
                    <path d="M16.4138 4.40814C13.5622 4.12555 10.6935 3.97998 7.83344 3.97998C6.13792 3.97998 4.44241 4.06561 2.74689 4.23688L1 4.40814" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M5.70996 3.54327L5.89835 2.42149C6.03536 1.60799 6.13812 1 7.5853 1H9.82886C11.276 1 11.3874 1.64224 11.5158 2.43006L11.7042 3.54327" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M14.5724 7.11426L14.0158 15.7374C13.9216 17.0818 13.8445 18.1265 11.4554 18.1265H5.95783C3.56869 18.1265 3.49162 17.0818 3.39743 15.7374L2.84082 7.11426" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.27686 13.4165H10.1284" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6.56592 9.99121H10.8475" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                  </svg> <span style={{ paddingLeft: '15px', color: '#F13139' }}>Delete User</span>
                </MenuItem>
              </Menu>
            </div>

          </div>
        )
      },
      width: '7%',
      sortable: false
    },

  ]

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Manage Users</h2>
      <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input type="text" placeholder="Search by Full name or Email" className="input input-bordered w-auto search-input-white focus:ring-0 focus:outline-none focus:border-primary font-normal text-14 text-muted" />
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">

          <GradientButton color='red' onClick={handleAddUserClick}>
            <span style={{
              width: "20px",
              height: "20px",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50px",
              marginRight: "5px"
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
              </svg>
            </span>
            Add New User
          </GradientButton>
        </div>
      </div>
      <div className='data-table-container mb-10'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={userListData}
          pagination
          selectableRows
          progressPending={loading}
        />

        <MUIModal title='Add User' openModal={openAddUserModal} closeModal={handleCloseAddUserModal} width={'25%'} >
          <AddUserForm closeModal={handleCloseAddUserModal} refreshPage={handleRefreshPage} />
        </MUIModal>

        <BootstrapDialog
          onClose={handleDeleteUserClose}
          aria-labelledby="customized-dialog-title"
          open={showDeleteUserModal}
          PaperProps={{
            sx: {
              width: '550px',
              height: '200px'
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Delete User
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleDeleteUserClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{UPDATE_USER_DELETE_SUBTITLE_1} <span className='font-semibold'>{`${selectedUserData !== undefined ? selectedUserData.firstName : ''} ${selectedUserData !== undefined ? selectedUserData.lastName : ''}`}</span> {UPDATE_USER_DELETE_SUBTITLE_2}</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            {/* <Button isGradient color="primary" label="Update" onClick={handleAssigneeClose} /> */}
            {/* <Button btntype={"button"} onClick={handleDeleteUserClose} label={"Cancel"} type={'default'} size={'small'} disabled={isModalSaveLoading}></Button> */}
            <OutlineButton color='gray' onClick={handleDeleteUserClose} width='130px'>Cancel</OutlineButton>
            {/* <Button btntype="submit" label={!isModalSaveLoading ? "Delete" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleDeleteUserConfirm} disabled={isModalSaveLoading}></Button> */}
            <GradientButton color='red' onClick={handleDeleteUserConfirm} width='130px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

      </div>
    </>
  );
};

export default UserList;
